import { formatSummaryFeature } from '~pricing/lib/PackageFeatures';

import { SummaryFeatureList, SummaryFeatureRuleMap } from '../types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const StandardMonthlyFeatureList: SummaryFeatureList = [];

const StandardMonthlyOverrideRules: SummaryFeatureRuleMap = {
  // Add feature rule overrides below
  support: () => formatSummaryFeature('email_support'),
  statistical_significance: () => formatSummaryFeature('text_analysis'),
};

export { StandardMonthlyFeatureList, StandardMonthlyOverrideRules };
